export default __webpack_public_path__ + "static/media/our_breakfast.a79ffa1c.png";